import { useEffect, useState } from 'react'
import { Row, Col, Button, Table, Card, Spinner, Form, Modal } from 'react-bootstrap'
import data, { urlapi } from '../../lib/backend/data'
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton'
import { addMoreDays, formatDateHoy } from '../../lib/helpers/dates';
import { esquema_productos } from '../../lib/esquemas';
import { useDispatch, useSelector } from 'react-redux';
import { BiSolidChevronRight } from 'react-icons/bi';
import { cerrarSesion } from '../../redux/actions/session';
import { AiOutlineFileExcel } from 'react-icons/ai';
import { AiOutlineDelete } from 'react-icons/ai';
import { AiFillPlusCircle } from "react-icons/ai";
import ConductoresListado from './list';
import ConductoresListadoTabla from './list_table';

const ModalConductores = (props) => {
    const initialDate = {
        startDate: new Date(),
        endDate: addMoreDays(new Date(),1),
        key: 'selection',
    }
    const dispatch = useDispatch()
    const [ showModal, setShowModal ] = useState(false)
    const session = useSelector(state => state.miusuario)
    const [ pedidos, setPedidos ] = useState([])
    const [ condicion_busqueda, setCondicionBusqueda ] = useState(props.condicion_default ? props.condicion_default : {})
    const [ loadingProveedores, setLoadingProveedores ] = useState(true)
    const [ parametroBusqueda, setParametroBusqueda ] = useState('')
    const trash = props.trash ? props.trash : false
    const [ total, setTotal ] = useState(0)
    const [ pagina, setPagina ] = useState(1)
    const token = session.tokenSession
    const [seleccionado, setSeleccionado ] = useState(false)
    const [loadingModal, setLoadingModal] = useState(false)
    const [loadingSeleccionados, setLoadingSeleccionados] = useState(false)
    const [seleccionados, setSeleccionados] = useState([])
    const titulo = props.titulo ? props.titulo : 'Seleccionar Conductores'
    


    const obtenerProveedores = async (page, query)=>{
        setLoadingModal(true)
        setLoadingProveedores(true)
        if(query) if(trash === true) query.status = 'trash'
        const condicion = query ? query : condicion_busqueda
        return fetch(`${data.urlapi}/ordenes/list/modal`,{
            method:'POST',
            body: JSON.stringify({
                condicion
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            console.log("RES:", res)
            if(!res){
                toast.error('Sin datos')
                return setLoadingProveedores(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setLoadingProveedores(false)
            }
            if(Array.isArray(res.datos) !== false){
                setPedidos(res.datos)
                setTotal(res.total)
            }
            setLoadingModal(false)
            return setLoadingProveedores(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            setLoadingModal(false)
            return setLoadingProveedores(false)
        })
    }

    
    const handleSubmitPalabra = (e) => {
       
        e.preventDefault()
        if(!parametroBusqueda){
            const condicion = {}
            setCondicionBusqueda(condicion)
            setPagina(1)
            return obtenerProveedores(1, condicion)
        }
        const condicion = { $text: { $search: parametroBusqueda }}
        setCondicionBusqueda(condicion)
        setPagina(1)
        setLoadingModal(false)
        return obtenerProveedores(1, condicion)
    }

    const handleChangePalabra = (e) => {
        const { value } = e.target
        return setParametroBusqueda(value)
    }

    const handleClose = () => {
        return setShowModal(false)
    }

    const onClickOrden = (seleccionados) => {
        console.log("Ordenes:", seleccionados)
        setShowModal(false)
        if(props.onClickOrden) return props.onClickOrden(seleccionados)
        return false
    }

    const cargandoScreen = () => {
        return <Row>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
            </Row>
    }


    const anadirPedidos = (p, ir) => {
        if(setSeleccionado) setSeleccionado(false)
        setLoadingSeleccionados(true)
        const { pedido, _id } = p
        const existe = seleccionados.filter(p => p.pedido === pedido);
        console.log("existe", existe)
      console.log("seleccionados", seleccionados)
      if(existe.length > 0){
       return toast.error("Ya seleccionaste este pedido")
    } else {       
        setLoadingSeleccionados(false)       
            return setSeleccionados(prev => {
                let actual = prev
                actual.push({id_pedido: _id, pedido: pedido })
                return ([...actual])
            })
        }  
        
    }

    
    const eliminar = (ir) => {  
        return setSeleccionados(prev => {
            let actual = prev
            actual.splice(ir, 1)
            return ([...actual])
        })
    }

    
    const mostrarSeleccionados = () => {
        if(seleccionados.length < 1) return <div>
            <p style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 10 }} className='text-danger'><i className="fa-solid fa-triangle-exclamation"></i> No has seleccionado ningun pedido</p>
        </div>       
        return <div>
             <h6 className='text-success'>Pedidos Seleccionados <b>{seleccionados.length}</b></h6> 
            {
             seleccionados.map((p, ir) => {                    
            return      <Card bg={ seleccionado === true ? 'primary' : 'white' } className={`p-3 mb-3 hover ${seleccionado === true ? 'text-white' : 'text-dark'}`}>
                    <div >
                    <tr key={p._id} style={{display: 'flex', justifyContent: 'space-between'}}>
                    <th>
                    <p style={{ fontSize: 12, fontWeight: 'bold', marginBottom: 10 }} className='text-success'><i className="fa-solid fa-circle-check"></i> has Seleccionado el pedido <b>{p.pedido}</b></p>
                    </th>
                    <th>
                    <AiOutlineDelete style={{fontSize: 32, fontWeight: 'bold'}} size={18} onClick={()=>eliminar(ir)} />
                    </th>
                    </tr>
                    </div>
                </Card>
                  })
                }            
        </div>
       
    }

    const onClickConductor = (data) => {
        handleClose()
        let titulo = ''
        if(data.modelo) titulo = data.modelo
        if(data.ano) titulo = `${titulo} ${data.ano}`
        if(data.patente) titulo = `${titulo} ${data.patente}`
        if(data.nombres) titulo = `${titulo} ${data.nombres}`
        if(data.apellidos) titulo = `${titulo} ${data.apellidos}`
        const driver = { ...data, titulo }
        if(props.onClick) return props.onClick(driver)
    }

    const listadoRecolecciones = () => {
    return <div>
            <ConductoresListadoTabla onClick={(data) => onClickConductor(data)} />
            </div>
    }


    const mostrarRecolecciones = () => {
        return <div>          
            <Button size='sm' md={12} variant='light' className='w-100' style={{ textTransform: "uppercase" }} onClick={() => setShowModal(true)}>{titulo}</Button>            
            <Modal show={showModal} size="lg" onHide={handleClose} centered >
                <Modal.Header closeButton>
                <Modal.Title><b>Conductores</b></Modal.Title>
                </Modal.Header>
                <Modal.Body className='m-0'>    
                    {listadoRecolecciones()}
                </Modal.Body>
            </Modal>
        </div>
    }


    return <div>
        {mostrarRecolecciones()}
        </div>

}

export default ModalConductores